import { ORDER_WITH_ITEMS } from '@pulse/fixtures/orders.fixtures';
import { storeToRefs } from 'pinia';

import { useClaimStore } from '~/store/claim';
import { useInStore } from '~/store/inStore';
import { useOrdersStore } from '~/store/orders';

export default defineNuxtRouteMiddleware(to => {
  const store = useOrdersStore();
  const inStoreClaim = useInStore();
  const { currentOrder } = storeToRefs(store);

  if (Object.hasOwn(to.query, 'fake')) {
    currentOrder.value = ORDER_WITH_ITEMS;
    const claimStore = useClaimStore();
    claimStore.setCurrentShipmentId(ORDER_WITH_ITEMS.fulfillments[0].sourceFulfillmentId);
  }

  if (to.path === '/start') {
    return store.reset();
  }

  if (to.path.includes('return')) {
    return;
  }

  if (to.path.includes('in-store')) {
    // Allow direct entry to pages that self-initialize the store (e.g. contact-info, sales-channel).
    // All other in-store pages depend on data collected in earlier steps, so redirect to /start.
    if (!inStoreClaim?.store && !to.path.includes('contact-info') && !to.path.includes('sales-channel')) {
      return navigateTo('/start');
    }

    //prevents user from going back after filing a claim
    if (!currentOrder.value) {
      return;
    }

    return navigateTo('/start');
  }

  if (!currentOrder.value && !(to.path.includes('/view') || to.path.includes('/print')) && !to.path.includes('/sign')) {
    return navigateTo('/start');
  }
});
